import { wealthProApi } from '../../redux/api';
import { applyPatch } from "fast-json-patch";

const contactDetailsApiEndpoints = wealthProApi.enhanceEndpoints({
    addTagTypes: ["masterAccountContactDetails"]
})
.injectEndpoints({
    endpoints: (builder) => ({
        createContactDetails: builder.mutation({
            query: ({ masterAccountId, ...rest }) => ({
                url: `api/clientdetails/master-accounts/${masterAccountId}/contacts`,
                method: 'POST',
                body: {
                    masterAccountId,
                    ...rest
                }
            }),
            async onQueryStarted({ masterAccountId, ...contactDetails }, { dispatch, queryFulfilled }) {
                try {
                    const { data: createData } = await queryFulfilled;
                    dispatch(wealthProApi.util.updateQueryData('fetchMasterAccountContactDetails', { masterAccountId }, (data) => {
                        // Find the index of the header row for the current contact type
                        const headerIndex = data.findIndex(el => el.type === contactDetails.type && el.contactDetailId == null);

                        const newContact = {
                            ...contactDetails,
                            contactDetailId: createData.contactDetailId,
                        }

                        // If the header is not found push the new contact to the end of the array
                        if (headerIndex < 0) {
                            data.push(newContact);
                            return;
                        }

                        // Find the index of the next header row or the end of the array
                        const nextHeaderIndex = data.slice(headerIndex).findIndex(el => !el.contactDetailId && el.typeDescription !== contactDetails.typeDescription);

                        // Insert the new contact before the index of the subsequent type header, if found
                        // Otherwise, push it to the end of the array
                        if (nextHeaderIndex < 0)
                            data.push(newContact);
                        else
                            data.splice(nextHeaderIndex, 0, newContact);
                    }));
                }
                catch { }
            }
        }),
        deleteContactDetails: builder.mutation({
            query: ({ masterAccountId, contactDetailId }) => ({
                url: `api/clientdetails/master-accounts/${masterAccountId}/contacts/${contactDetailId}`,
                method: 'DELETE'
            }),
            async onQueryStarted({ contactDetailId, masterAccountId }, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;
                    dispatch(wealthProApi.util.updateQueryData('fetchMasterAccountContactDetails', { masterAccountId }, (data) => {
                        return data.filter(el => el.contactDetailId !== contactDetailId);
                    }));
                }
                catch { }
            }
        }),
        fetchMasterAccountContactDetailsEmailList: builder.query({
            query: ({ masterAccountId }) => `api/clientdetails/master-accounts/${masterAccountId}/contacts/list?types=2&types=4`
        }),
        fetchMasterAccountContactDetailsMobileList: builder.query({
            query: ({ masterAccountId }) => `api/clientdetails/master-accounts/${masterAccountId}/contacts/list?types=1`
        }),
        fetchMasterAccountContactDetails: builder.query({
            query: ({ masterAccountId, ...queryParams }) => `api/clientdetails/master-accounts/${masterAccountId}/contacts/${queryParams ? '?' + new URLSearchParams(queryParams) : ''}`,
            serializeQueryArgs: ({ endpointName, masterAccountId }) => ({ masterAccountId }),
            providesTags: (result, error, arg) => {
                return ['masterAccountContactDetails'];
            }
        }),
        patchContactDetails: builder.mutation({
            query: ({ masterAccountId, operations }) => ({
                url: `api/clientdetails/master-accounts/${masterAccountId}/contacts`,
                method: 'PATCH',
                body: {
                    patchRequests: operations
                }
            }),
            async onQueryStarted({ masterAccountId, operations }, { dispatch, queryFulfilled }) {
                const result = dispatch(wealthProApi.util.updateQueryData('fetchMasterAccountContactDetails', { masterAccountId }, (data) => {
                    operations.forEach(op => {
                        var contact = data.find(el => el.contactDetailId === op.contactDetailId);
                        applyPatch(contact, op.operations, true);
                    });
                }));
                try {
                    await queryFulfilled;
                }
                catch {
                    result.undo();
                }
            }
        })
    })
});

export const {
    useCreateContactDetailsMutation,
    useDeleteContactDetailsMutation,
    useFetchMasterAccountContactDetailsEmailListQuery,
    useFetchMasterAccountContactDetailsMobileListQuery,
    useFetchMasterAccountContactDetailsQuery,
    useLazyFetchMasterAccountContactDetailsEmailListQuery,
    useLazyFetchMasterAccountContactDetailsMobileListQuery,
    usePatchContactDetailsMutation
} = contactDetailsApiEndpoints;